export default __webpack_public_path__ + "static/how_it_works_step_6_desktop_tablet-5990608939963e6ecbcd74a73f647173.webp";